
import { Component, Mixins } from 'vue-property-decorator';
import { mdiFlash } from '@mdi/js';
import { VuetifyMixin } from '../../mixins';

@Component
export default class UpgradeNowButton extends Mixins(VuetifyMixin){
	mdiFlash = mdiFlash;
}
